import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';

import { SurveyStore } from '@player/shared/services/survey-store.service';

import { OutcomeData } from '@shared/models/survey.model';
import { AsyncPipe } from '@angular/common';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';

@Component({
  selector: 'promo-text',
  templateUrl: './promo-text.component.html',
  styleUrls: ['./promo-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, SharedModuleForPlayer],
})
export class PromoText {
  readonly ss = inject(SurveyStore);

  @Input() outcomeData?: OutcomeData;
}
